(function() {
  function initDiscoverSection(section) {
    var list = section.querySelector('.discover-list');
    if (!list) return;
    var button = section.querySelector('.view-more-btn');
    var batchSize = button ? parseInt(button.getAttribute('data-batch'), 10) || 9 : 9;
    var sectionId = section.getAttribute('data-section-id');
    var nextPageUrl = button ? button.getAttribute('data-next-url') || '' : '';
    var isLoading = false;

    function getHiddenItems() {
      return Array.prototype.slice.call(section.querySelectorAll('.discover-item.hidden'));
    }

    function hideButton() {
      if (button) {
        button.classList.add('hidden');
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('hidden', '');
      }
    }

    function showButton() {
      if (button) {
        button.classList.remove('hidden');
        button.removeAttribute('hidden');
        button.removeAttribute('aria-hidden');
        if (!isLoading) {
          button.removeAttribute('disabled');
        }
      }
    }

    function updateButtonState() {
      if (!button) return;
      var hasHiddenItems = getHiddenItems().length > 0;
      var hasNextPage = !!nextPageUrl;
      if (!hasHiddenItems && !hasNextPage) {
        hideButton();
      } else {
        showButton();
        try {
          if (window.getComputedStyle(button).display === 'none') {
            button.style.display = 'inline-block';
          }
        } catch (e) {}
      }
    }

    function appendNextPageItems(doc) {
      var incomingSection = doc.querySelector('[data-discover][data-section-id="' + sectionId + '"]');
      if (!incomingSection) return false;
      var incomingList = incomingSection.querySelector('.discover-list');
      if (!incomingList) return false;

      var incomingItems = Array.prototype.slice.call(incomingList.querySelectorAll('.grid__item.article'));
      incomingItems.forEach(function(item) {
        if (!item.classList.contains('discover-item')) {
          item.classList.add('discover-item');
          item.classList.add('hidden');
        }
        list.appendChild(item.cloneNode(true));
      });

      var incomingButton = incomingSection.querySelector('.view-more-btn');
      nextPageUrl = incomingButton ? incomingButton.getAttribute('data-next-url') || '' : '';
      return incomingItems.length > 0;
    }

    function buildSectionUrl(urlValue) {
      if (!urlValue) return '';
      var url = new URL(urlValue, window.location.origin);
      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }
      return url.toString();
    }

    function fetchNextPage() {
      if (!nextPageUrl || isLoading) return Promise.resolve(false);

      var requestUrl = buildSectionUrl(nextPageUrl);
      if (!requestUrl) return Promise.resolve(false);

      isLoading = true;
      if (button) button.setAttribute('disabled', 'disabled');

      return fetch(requestUrl, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to fetch next page.');
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          return appendNextPageItems(doc);
        })
        .catch(function() {
          nextPageUrl = '';
          return false;
        })
        .finally(function() {
          isLoading = false;
          updateButtonState();
        });
    }

    function revealNextBatch() {
      var hiddenItems = getHiddenItems();
      if (hiddenItems.length > 0) {
        hiddenItems.slice(0, batchSize).forEach(function(el) {
          el.classList.remove('hidden');
        });
        updateButtonState();
        return;
      }

      if (!nextPageUrl) {
        updateButtonState();
        return;
      }

      fetchNextPage().then(function(loaded) {
        if (!loaded) {
          updateButtonState();
          return;
        }
        revealNextBatch();
      });
    }

    if (button) {
      button.addEventListener('click', function() {
        revealNextBatch();
      });

      updateButtonState();
    }
  }

  function onLoad() {
    document.querySelectorAll('[data-discover]').forEach(initDiscoverSection);
  }

  // Support Shopify Theme Editor dynamic section reloads
  document.addEventListener('shopify:section:load', function(event) {
    var scope = event.target;
    var container = scope && scope.querySelector ? scope.querySelector('[data-discover]') : null;
    if (container) initDiscoverSection(container);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
    window.addEventListener('load', onLoad);
  } else {
    onLoad();
  }
})();